import React from "react";

import Icon from "../Icon";

import { CounterButton, CounterValue, Container } from "./styled";

export type CounterProps = {
  //   className?: string;
  value: number;
  onDecrement: () => void;
  onIncrement: () => void;
  disabled?: boolean;
};

const Counter = ({
  //   className,
  value,
  onIncrement,
  onDecrement,
  disabled,
}: CounterProps) => {

  return (
    <Container>
      <CounterButton
        disabled={disabled || value === 0}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          !disabled && onDecrement();
        }}
        type="button"
        aria-label="Decrease"
      >
        <Icon name="minus" size="24" />
      </CounterButton>
      <CounterValue disabled={disabled || value === 0}>{value}</CounterValue>
      <CounterButton
        disabled={disabled || value === 0}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          !disabled && onIncrement();
        }}
        type="button"
        aria-label="Increase"
      >
        <Icon name="plus" size="24" />
      </CounterButton>
    </Container>
  );
};

export { Counter };
